import { Button, ButtonProps, Stack, styled } from "@tm/components"
import { ComponentType } from "react"

export const WrappedStack = styled(Stack)({
    flexWrap: "wrap",
    flexDirection: "row",
    marginBottom: 4,
    ">:not(style)": {
        margin: "0 4px 4px 0",
    },
})

export const CustomStyledButton = styled(Button, {
    name: "CustomButton",
    slot: "root",
    overridesResolver: (_, styles) => styles.root,
})({}) as ComponentType<ButtonProps>
